module.exports = __webpack_public_path__ + "static/logo.uninterrupted-72424d783a8d9022e00cca27e4c46201.svg";